<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

<salonmonster-tap-retry
  *ngIf="errorOccurred"
  (click)="loadPage()"
></salonmonster-tap-retry>

<mat-list *ngIf="!isLoading && !errorOccurred">
  <h3 mat-subheader>{{ 'PROFILE.UPCOMING_BOOKINGS' | translate }}</h3>
  <span
    class="sm-booking-empty"
    mat-list-item
    *ngIf="upcomingBookings.count() == 0"
    >{{ 'PROFILE.NO_UPCOMING_BOOKINGS' | translate }}<br /><br
  /></span>
  <sm-booking-item
    mat-list-item
    [booking]="booking"
    [showButtons]="true"
    [cancellationInProgress]="cancellationInProgress"
    (bookingDateChange)="bookingDateChange($event)"
    (bookingCancellation)="bookingCancellation($event, bookingRowIndex)"
    *ngFor="let booking of upcomingBookings; let bookingRowIndex = index"
  >
  </sm-booking-item>

  <h3 mat-subheader>{{ 'PROFILE.PREVIOUS_BOOKINGS' | translate }}</h3>
  <span
    class="sm-booking-empty"
    mat-list-item
    *ngIf="previousBookings.count() == 0"
    >{{ 'PROFILE.NO_PREVIOUS_BOOKINGS' | translate }}</span
  >
  <sm-booking-item
    mat-list-item
    [booking]="booking"
    *ngFor="let booking of previousBookings"
  >
  </sm-booking-item>
</mat-list>
